<template>
  <div class="avator">
    <div class="top">
      <el-button plain type="primary" size="small" @click="addInfor">
        创建新企业
      </el-button>
      <el-input v-model="keyword" placeholder="请输入企业名称" style="width:320px;" clearable maxlength="30" size="small" @input="getList">
        <i slot="prefix" class="el-input__icon el-icon-search" />
      </el-input>
    </div>
    <div v-for="(item, index) in infoList" :key="index" class="info">
      <div class="info_top"
        style="border-bottom: 1px solid rgba(213, 222, 239, 0.47);background-color: rgba(71, 119, 231, 0.03);">
        <div class="qiye">
          <span class="name">{{ item.enterpriseName }}</span>
          <span v-if="item.isCreateUser == '1'" class="person">负责人</span>
          <span v-if="item.enterpriseId == enterpriseId" class="person">当前企业</span>
        </div>
        <span v-if="item.status == 1 && item.joinStatus == 1 && item.isEnabled == 0" style="color:#AAB9CE">已被企业禁用</span>
        <span v-if="item.status == 1 && item.joinStatus == 0" class="statu" style="color:#AAB9CE">被邀请,待处理</span>
        <span v-if="item.status == 4" style="color:#AAB9CE" class="statu">企业已被禁用</span>
        <span v-if="item.status == 0" class="statu" style="color:#FAA01A">待审核</span>
        <span v-if="item.status == 2" style="color:#F5634A" class="statu">审核驳回</span>
      </div>
      <div class="info_top">
        <template v-if="item.isCreateUser == '1'">
          <span v-if="item.isCreateUser == '1'" class="dissolution" @click="dissolutionBtn(item)">解散企业</span>
          <span v-if="item.isCreateUser == '1'" class="dissolution" @click="qualificationFormBtn(item)">查看企业资质</span>
        </template>
        <template v-else>
          <span v-if="item.joinStatus != 0" class="dissolution" @click="signOutBtn(item)">退出企业</span>
          <span v-else class="dissolution"></span>
        </template>
        <div>
          <span v-if="item.status == 1 && item.joinStatus == 0" class="enter" @click="handleBtn(item)">去处理></span>
          <span v-else class="enter" @click="enterInfo(item)">进入该企业></span>
        </div>
      </div>
    </div>
    <div v-if="infoList.length===0" class="noDataStyle">
      <img :src="noDataImg">
    </div>
    <el-dialog v-dialogDrag :visible.sync="qualificationVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="600px"
      title="企业资质" top="50px">
      <el-form ref="detailForm" size="small" :model="detailForm" label-width="80px">
        <div>
          <p class="tit"></p>
          <span style="color:var(--key-color);font-size:18px">企业资质信息</span>
        </div>
        <div style="margin-left:2px">
          <div class="xinxi">
            <span>企业全称：</span>
            <span>{{ detailForm.enterpriseName }}</span>
          </div>
          <div class="xinxi">
            <span>工商营业执照：</span>
            <div v-viewer style="display: inline-block;">
              <img :src="questionImgListUrl(detailForm.imgsrc)"
                style="width:150px;height:150px;vertical-align: top;border:1px solid" alt="" />
            </div>
          </div>
          <div class="xinxi">
            <span>统一社会信用代码：</span>
            <span>{{ detailForm.creditCode }}</span>
          </div>
          <div class="xinxi">
            <span>其他证明材料(选填)：</span>
            <ul style="display: inline-block;vertical-align: top;cursor: pointer;">
              <li v-for="(item, index) in detailForm.otherFile" :key="index"
                :class="[item.fileId === cur ? 'active1' : '']" style="width:200px"
                @mouseover.stop="mouseoverenet(item)">
                <i class="el-icon-document"></i>
                <span>{{ item.fileName }}</span>
                <i v-if="item.fileId === cur" class="el-icon-download" @click="downloadFile(item)"></i>
              </li>
            </ul>
          </div>
        </div>
        <div style="margin-top:20px">
          <p class="tit"></p>
          <span style="color:var(--key-color);font-size:18px">企业负责人信息</span>
        </div>
        <div style="margin-left:2px">
          <div class="xinxi">
            <span>姓名：</span>
            <span>{{ detailForm.name }}</span>
          </div>
          <div class="xinxi">
            <span>手机号：</span>
            <span>{{ detailForm.phone }}</span>
          </div>
          <div class="xinxi">
            <span>身份证号码：</span>
            <span>{{ detailForm.idCard }}</span>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/CommonDP/service/userCenter-service";
import enterpriseService from "@/CommonDP/service/enterprise-service";
import { mapState } from "vuex";
import requeslogout from "@/CommonDP/service/login-service";
import { downloadFile, downloadUrlone } from "@/CommonDP/utils";
export default {
  name: "MyEnterprise",
  data() {
    return {
      imgSrc: "",
      infoList: [],
      qualificationVisible: false,
      detailForm: {
        enterpriseName: "",
        creditCode: "",
        name: "",
        phone: "",
        idCard: "",
        otherFile: [],
        imgsrc: "",
        remark: "",
        createTime: ""
      },
      cur: "",
      keyword: "",
      noDataImg: require("@/CommonDP/assets/workProjectBoard/notNotice.png")
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const { data } = await request.queryEnterpriseInfoList(this.keyword);
      this.infoList = data.filter(({ status }) => status !== 3);
    },
    addInfor() {
      this.checked = false;
      var params = {
        enterpriseName: "",
        creditCode: "",
        userName: "",
        idCard: "",
        verifyCode: "",
        fileList1: [],
        fileList2: []
      };
      localStorage.setItem("setenterpriseForm", JSON.stringify(params));
      localStorage.setItem("setchecked", JSON.stringify(this.checked));
      const { href } = this.$router.resolve({
        path: "/consentagree",
        query: { greetype: "enterprisepage", pagetype: "1" }
      });
      window.open(href, "_blank");
    },
    async enterInfo(item) {
      if (item.status === 2 || item.status === 0) {
        // 审核驳回 2  待审核 0
        const { href } = this.$router.resolve({
          path: "/creationcomplete",
          query: { id: item.enterpriseId }
        });
        window.open(href, "_blank");
      } else if (item.status === 1) {
        // 审核通过
        if (item.joinStatus === 0) {
          // 审核中加入
          const { href } = this.$router.resolve({
            path: "/noenterprise",
            query: { showtype: 3, name: item.enterpriseName }
          });
          window.open(href, "_blank");
        } else if (item.joinStatus === 1) {
          // 通过
          if (item.isEnabled === 1) {
            const res = await enterpriseService.userselectEnterprise(item.enterpriseId);
            if (res.result === "0") {
              // 如果是试用企业
              const data = {
                createTime: "",
                enterPrjTime: "",
                prjCode: "",
                prjId: "",
                prjName: ""
              };
              this.$store.dispatch("updatePrj", data);
              this.$store.dispatch("setCatalogToken", "0");
              this.$store.dispatch("setIsTrial", item.isTrial);
              this.$store.dispatch("setUnauthorized", 1);
              this.$store.dispatch("setEnterpriseId", item.enterpriseId);
              this.$store.dispatch("setRouterNav", []);
              this.$store.commit("saveFlatRoutes", []);
              this.$store.dispatch("setHasRoles", true);
              this.$store.dispatch("setRepeatEnterpriseDept", true);
              // await this.$store.dispatch("queryEnterpriseDept");
              await this.$store.dispatch("GetModuleList", item.enterpriseId);
              // localStorage.clear();
              await this.$router.push({ name: "mainMg" });
            }
          } else {
            // 禁用
            const { href } = this.$router.resolve({
              path: "/noenterprise",
              query: { showtype: 2, name: item.enterpriseName }
            });
            window.open(href, "_blank");
          }
        }
      } else if (item.status === 4) {
        const { href } = this.$router.resolve({
          path: "/noenterprise",
          query: { showtype: 4, name: item.enterpriseName }
        });
        window.open(href, "_blank");
      }
    },
    async qualificationFormBtn(row) {
      this.qualificationVisible = true;
      const res = await request.getEnterpriseDetails(row.enterpriseId);
      this.detailForm = res.data;
      if (res.data.businessLicenseFile != null) {
        this.detailForm.imgsrc = res.data.businessLicenseFile.fileId;
      }
    },
    // 解散企业
    async dissolutionBtn(row) {
      await this.$confirm(`您确定要解散当前${row.enterpriseName}吗`, "警告", {
        type: "warning"
      });
      const res = await request.updateEnterpriseDissolve(row.enterpriseId);
      if (row.enterpriseId === this.enterpriseId) {
        if (res.result === "0") {
          await this.$message.info(`当前登录的${row.enterpriseName}已经成功解散，请重新登录`);
          requeslogout.logout();
          this.$router.replace("/");
        }
      } else {
        await this.$message.success(`${row.enterpriseName}已经成功解散`);
        this.getList();
      }
    },
    // 退出企业
    async signOutBtn(row) {
      await this.$confirm(`您确定要退出当前${row.enterpriseName}吗`, "警告", {
        type: "warning"
      });
      const res = await request.userexitEnterprise(row.enterpriseId);
      if (row.enterpriseId === this.enterpriseId) {
        if (res.result === "0") {
          await this.$message.info(`当前登录的${row.enterpriseName}企业已经成功退出`);
          const { data } = await enterpriseService.usergetEnterpriseList();
          var length = data.length;
          if (length) {
            this.$router.replace("/changeenterprise");
          } else {
            this.$router.replace({
              path: "/enterprisepage",
              query: { pagetype: "0" }
            });
          }
        }
      } else {
        await this.$message.success(`${row.enterpriseName}已经成功退出`);
        this.getList();
      }
    },
    questionImgListUrl(imgsrc) {
      if (!imgsrc) {
        return;
      }
      return downloadUrlone(imgsrc);
    },
    mouseoverenet(item) {
      if (item) {
        this.cur = item.fileId;
      }
    },
    downloadFile(item) {
      const url = downloadUrlone(item.fileId);
      downloadFile(url);
    },
    // 被邀请，去处理
    handleBtn(item) {
      const { href } = this.$router.resolve({
        path: "/joinEnterprise",
        query: { code: item.inviteCode }
      });
      window.open(href, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.avator {
  padding: 24px 27px;
  box-sizing: border-box;
  .top{
    width: 830px;
    display: flex;
    justify-content: space-between;
  }
  .info {
    width: 830px;
    height: 112px;
    border-radius: 4px;
    border: 1px solid rgba(213, 222, 239, 0.77);
    margin: 24px 0 43px 0;
    .info_top {
      display: flex;
      line-height: 56px;
      padding: 0 10px;
      justify-content: space-between;
      .qiye {
        .name {
          font-size: 18px;
        }
        .person {
          border: 1px solid #4777e7;
          font-size: 14px;
          border-radius: 12px;
          padding: 2px 8px;
          color: #4777e7;
          margin-left: 10px;
        }
      }
      .dissolution {
        font-size: 15px;
        color: #58667a;
        cursor: pointer;
      }
      .enter {
        font-size: 15px;
        color: var(--theme-color);
        cursor: pointer;
      }
    }
  }
  .info:hover {
    box-shadow: 10px 10px 8px #e7ebef;
  }
  .statu {
    font-size: 16px;
  }
  .noDataStyle{
    width: 830px;
    height: calc(100vh - 163px);
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.tit {
  width: 2px;
  height: 14px;
  background: var(--theme-color);
  border-radius: 8px;
  display: inline-block;
}
.xinxi {
  color: var(--key-color);
  font-size: 15px;
  margin-top: 20px;
}
.active1 {
  background: #f5f7fa;
  color: var(--theme-color);
}
</style>
